import { render, staticRenderFns } from "./QuickOrder.vue?vue&type=template&id=6973447d&"
import script from "./QuickOrder.vue?vue&type=script&lang=ts&"
export * from "./QuickOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports